import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="flex w-full flex-col items-center justify-between px-1 pb-8 pt-3 lg:px-8 xl:flex-row">
      <h5 className="mb-4 text-center text-sm font-medium text-gray-600 sm:!mb-0 md:text-lg">
        <p className="mb-4 text-center text-sm text-gray-600 sm:!mb-0 md:text-base">
          ©{1900 + new Date().getYear()} <span className="text-blue-1000">Hypertrace.io</span>
        </p>
      </h5>
      <div>
        <ul className="flex flex-wrap items-center gap-3 sm:flex-nowrap md:gap-10">
          <li>
            <Link to="/admin/support" className="text-base font-medium text-blue-1000 hover:text-gray-600">
              Support
            </Link>
          </li>
          <li>
            <Link to="/admin/license" className="text-base font-medium text-blue-1000 hover:text-gray-600">
              License
            </Link>
          </li>
          <li>
            <Link to="/admin/terms-of-use" className="text-base font-medium text-blue-1000 hover:text-gray-600">
              Terms of Use
            </Link>
          </li>
          <li>
            <Link to="/admin/blog" className="text-base font-medium text-blue-1000 hover:text-gray-600">
              Blog
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
